import { Parameters } from '../../../models/index';
import { UseCase } from '../../UseCase';

export namespace DeleteParameter {
    export interface Params<P extends string> {
        params?: Parameters<P>;
        name: P;
    }
}

export class DeleteParameter<P extends string>
    implements UseCase<DeleteParameter.Params<P>, Parameters<P>>
{
    execute({ params, name }: DeleteParameter.Params<P>): Parameters<P> {
        params = params || {};
        params.parameters = params.parameters || [];
        const index = params.parameters.findIndex((p) => p.name === name);
        if (index > -1) {
            params.parameters.splice(index, 1);
        }

        return params;
    }
}
